import { memo } from "react";
import { Link } from "react-router-dom";

function BannerItem({ banner }) {

    const content = (
        <picture>

            {banner.mobileImage && (
                <source
                    media="(max-width:768px)"
                    srcSet={banner.mobileImage}
                />
            )}

            <img
                src={banner.image}
                alt={banner.title}
                loading="lazy"
                decoding="async"
                fetchPriority="low"
              
            />

        </picture>
    );

    if (banner.isExternal) {

        return (

            <a
                href={banner.link}
                target={banner.target}
                rel="noopener noreferrer"
                className="home-banner"
            >
                {content}
            </a>

        );
    }

    return (

        <Link
            to={banner.link}
            className="home-banner"
        >
            {content}
        </Link>

    );
}

export default memo(BannerItem);